/**
 * Format Context Utility
 *
 * Provides a way to temporarily override format constants during rendering.
 * This allows the dev control panel to inject format overrides without
 * refactoring all rendering functions to accept format parameters.
 *
 * Note: This uses a module-level variable which is generally discouraged,
 * but is acceptable here for dev-only functionality that avoids invasive refactoring.
 */

import { lineAngleFormat, type FormatOptions } from '@alchemiesolns/svg-format';

// Module-level variable holding the current format (with overrides)
let currentFormat: FormatOptions = lineAngleFormat;

/**
 * Get the current format (with runtime overrides applied)
 */
export function getFormat(): FormatOptions {
    return currentFormat;
}

/**
 * Set the current format (called by rendering hook)
 * @internal
 */
export function setFormat(format: FormatOptions): void {
    currentFormat = format;
}

/**
 * Reset to base format (without overrides)
 * @internal
 */
export function resetFormat(): void {
    currentFormat = lineAngleFormat;
}
